// import * as Filters from 'filters';

export default function main() {
    // const $filterDiv = document.querySelector('#filter-badges') as HTMLElement;
    // Filters.InitFilters($filterDiv);

    function initBanner(bannerID: string) {
        const $banner = document.querySelector(`#${bannerID}`) as HTMLElement;
        const $headerBar = document.querySelector('header') as HTMLElement;
        const $headerParent = $headerBar.parentNode;
        $headerParent?.insertBefore($banner, $headerBar.nextSibling);
    }

    initBanner('banner-image-parent');

    // const $filterDropdowns = document.querySelectorAll('.filter-dropdown-btn') as NodeListOf<HTMLButtonElement>;
    // $filterDropdowns.forEach(i => {
    //     i.addEventListener('click', () => {
    //         const param = i.getAttribute('data-filter-param') ?? '';
    //         const currentFilters = Filters.GetFilters();
    //         if (param in currentFilters) {
    //             const $thisFilterChecks = document.querySelectorAll('.filter-check-input') as NodeListOf<HTMLInputElement>;
    //             $thisFilterChecks.forEach(j => {
    //                 const value = j.getAttribute('data-filter-value') ?? '';
    //                 j.checked = currentFilters[param].includes(value);
    //             });
    //         }
    //     });
    // });

    // const $filterChecks = document.querySelectorAll('.filter-check-input') as NodeListOf<HTMLInputElement>;
    // $filterChecks.forEach(k => {
    //     k.addEventListener('change', () => {
    //         const param = k.getAttribute('data-filter-param') ?? '';
    //         const value = k.getAttribute('data-filter-value') ?? '';
    //         if (k.checked) {
    //             Filters.AddFilter(param, value);
    //         } else {
    //             Filters.RemoveFilter(param, value);
    //         }
    //     });
    // });

    // // initialize three filters as demos

    // const $demoFilter1 = document.querySelector('#check-Lorem-Consectetur') as HTMLInputElement;
    // const $demoFilter2 = document.querySelector('#check-Ipsum-Aliquam') as HTMLInputElement;
    // const $demoFilter3 = document.querySelector('#check-Ipsum-Convallis') as HTMLInputElement;

    // const $demos = [$demoFilter1, $demoFilter2, $demoFilter3];

    // $demos.forEach(m => {
    //     m.checked = true;
    //     m.dispatchEvent(new Event('change'));
    // });
}